import { Globe, Languages, MapPin, Phone } from "lucide-react";

const ROW = "flex min-w-0 items-start gap-2.5 py-2.5";

/** Address, phone and the map, one under the other. */
export default function DetailContact({ labels = {}, address, phone, website, area, languages, directionsUrl, wazeUrl, map }) {
  const hasRows = address || phone || website || area || languages;
  if (!hasRows && !map) return null;

  return (
    <section id="location" className="scroll-mt-28">
      <h2 className="text-[16px] font-extrabold tracking-[-0.01em] text-[#171717] dark:text-[#f2efe9]">{labels.heading}</h2>

      {hasRows && (
        <div className="mt-1 divide-y divide-[#EDEBE5] dark:divide-white/[0.08]">
          {address && (
            <div className={ROW}>
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#8d8d88]" strokeWidth={1.9} />
              <div className="min-w-0">
                <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#8d8d88]">{labels.address}</div>
                <div className="mt-0.5 break-words text-[13.5px] font-semibold text-[#24231f] dark:text-[#f0ede6]">{address}</div>
              </div>
            </div>
          )}
          {phone && (
            <div className={ROW}>
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-[#8d8d88]" strokeWidth={1.9} />
              <div className="min-w-0">
                <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#8d8d88]">{labels.phone}</div>
                <a href={"tel:" + phone} className="mt-0.5 block break-words text-[13.5px] font-semibold text-[#24231f] hover:underline dark:text-[#f0ede6]">{phone}</a>
              </div>
            </div>
          )}
          {website && (
            <div className={ROW}>
              <Globe className="mt-0.5 h-4 w-4 shrink-0 text-[#8d8d88]" strokeWidth={1.9} />
              <div className="min-w-0">
                <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#8d8d88]">{labels.website}</div>
                <a href={website} target="_blank" rel="noopener noreferrer" className="mt-0.5 block break-words text-[13.5px] font-semibold text-[#24231f] hover:underline dark:text-[#f0ede6]">{labels.visitWebsite}</a>
              </div>
            </div>
          )}
          {area && (
            <div className={ROW}>
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#8d8d88]" strokeWidth={1.9} />
              <div className="min-w-0">
                <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#8d8d88]">{labels.area}</div>
                <div className="mt-0.5 break-words text-[13.5px] font-semibold text-[#24231f] dark:text-[#f0ede6]">{area}</div>
              </div>
            </div>
          )}
          {languages && (
            <div className={ROW}>
              <Languages className="mt-0.5 h-4 w-4 shrink-0 text-[#8d8d88]" strokeWidth={1.9} />
              <div className="min-w-0">
                <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#8d8d88]">{labels.languages}</div>
                <div className="mt-0.5 break-words text-[13.5px] font-semibold text-[#24231f] dark:text-[#f0ede6]">{languages}</div>
              </div>
            </div>
          )}
        </div>
      )}

      {map && (
        <div className="mt-3">
          <div className="relative h-[180px] overflow-hidden rounded-[12px] border border-[#E4E2DC] dark:border-white/[0.10] sm:h-[220px]">
            {map}
            <a
              href={directionsUrl}
              target="_blank"
              rel="noreferrer"
              className="absolute bottom-2.5 left-1/2 -translate-x-1/2 rounded-full bg-[#171717] px-4 py-2 text-[11px] font-bold text-white shadow-[0_3px_12px_rgba(0,0,0,0.25)] transition hover:bg-[#33332f]"
            >
              {labels.viewMap}
            </a>
          </div>
          {wazeUrl && (
            <div className="mt-2 flex gap-2">
              <a href={directionsUrl} target="_blank" rel="noreferrer" className="flex h-10 flex-1 items-center justify-center rounded-[9px] border border-[#E4E2DC] text-[11.5px] font-bold text-[#24231f] transition hover:bg-[#f5f4f0] dark:border-white/[0.12] dark:text-[#eeeae2] dark:hover:bg-white/[0.06]">{labels.googleMaps}</a>
              <a href={wazeUrl} target="_blank" rel="noreferrer" className="flex h-10 flex-1 items-center justify-center rounded-[9px] border border-[#E4E2DC] text-[11.5px] font-bold text-[#24231f] transition hover:bg-[#f5f4f0] dark:border-white/[0.12] dark:text-[#eeeae2] dark:hover:bg-white/[0.06]">{labels.waze}</a>
            </div>
          )}
        </div>
      )}
    </section>
  );
}